module.exports = __webpack_public_path__ + "static/media/JsForMe.cab2ec57.png";